import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { deletePayee, fetchPayees } from 'suits-me-npm/actions';
import {
    getPayees,
    getPayeesIsFetching,
    getPayeesError,
    getPayeesIsPosting,
    getLastPayeePage,
    getPayeesPostError,
} from 'suits-me-npm/selectors';
import { hideModal, showModal } from 'actions/modal';
import { CONFIRM_MODAL, DISMISS_MODAL } from 'constants/shared/modalTypes';
import {
    PAYMENT,
    PAYMENT_ADD_PAYEE,
    PAYMENT_MANAGE_PAYEES,
} from 'constants/shared/routes';

import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import ManagePayees from '../presentational/ManagePayees';
import ButtonContainer from 'components/shared/generic/buttonContainer/presentational/ButtonContainer';
import Button from 'components/shared/generic/button/presentational/Button';
import useTranslate from 'suits-me-npm/languages/useTranslate';
import { usePrevious } from 'suits-me-npm/utils';

const ManagePayeesContainer = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const last = useSelector(getLastPayeePage);
    const payee = useSelector(getPayees);
    const isFetching = useSelector(getPayeesIsFetching);
    const error = useSelector(getPayeesError);
    const isPosting = useSelector(getPayeesIsPosting);
    const postError = useSelector(getPayeesPostError);
    const prevPostError = usePrevious(postError);
    const translate = useTranslate('managePayees');

    const handleFetchPage = (page = 1) => {
        dispatch(fetchPayees(page));
    };

    const handleAddNewPayee = () => {
        history.push(PAYMENT_ADD_PAYEE, { backRoute: PAYMENT_MANAGE_PAYEES });
    };

    const handleDelete = payee => {
        dispatch(
            showModal({
                type: CONFIRM_MODAL,
                props: {
                    title: translate('removePayee'),
                    message: translate('confirmationMessage'),
                    handleSubmit: () => {
                        dispatch(deletePayee(payee)).then(() =>
                            dispatch(hideModal()),
                        );
                    },
                    isPosting,
                },
            }),
        );
    };

    const handleDeleteError = error => {
        console.log(error);
        dispatch(
            showModal({
                type: DISMISS_MODAL,
                props: {
                    title: translate('removePayee'),
                    message: translate('errorDeleteError'),
                    handleCancel: () => {
                        dispatch(hideModal());
                    },
                },
            }),
        );
    };

    useEffect(() => {
        dispatch(fetchPayees());
    }, []);

    useEffect(() => {
        if (!prevPostError && postError) {
            dispatch(hideModal());
            handleDeleteError();
        }
    }, [postError, prevPostError]);

    return (
        <PageContainer className="manage-payee-container">
            <SectionTitle title={translate('titleText')} backRoute={PAYMENT} />
            <DataCheck data={payee} isLoading={isFetching} error={error}>
                <ManagePayees
                    data={payee}
                    last={last}
                    handleDelete={handleDelete}
                    handleFetchPage={handleFetchPage}
                    noDataMessage={translate('noDataMessage')}
                />
            </DataCheck>
            <ButtonContainer>
                <Button onClick={handleAddNewPayee} className="outline center">
                    {translate('addNewPayee')}
                </Button>
            </ButtonContainer>
        </PageContainer>
    );
};

export default ManagePayeesContainer;
